import { create } from 'zustand'
import type { ProjectInputItem } from '../lib/models'

interface AppState {
  toast: { message: string; tone: 'success' | 'error' | 'warning' } | null
  selectedInventoryCode: string | null
  projectDraft: { step: number; items: ProjectInputItem[] }
  showToast: (message: string, tone?: 'success' | 'error' | 'warning') => void
  clearToast: () => void
  selectInventory: (code: string | null) => void
  setProjectDraft: (draft: Partial<AppState['projectDraft']>) => void
  clearProjectDraft: () => void
}

export const useAppStore = create<AppState>((set) => ({
  toast: null,
  selectedInventoryCode: null,
  projectDraft: { step: 1, items: [] },
  showToast: (message, tone = 'success') => set({ toast: { message, tone } }),
  clearToast: () => set({ toast: null }),
  selectInventory: (selectedInventoryCode) => set({ selectedInventoryCode }),
  setProjectDraft: (draft) => set((state) => ({ projectDraft: { ...state.projectDraft, ...draft } })),
  clearProjectDraft: () => set({ projectDraft: { step: 1, items: [] } }),
}))
